import { ValidationResult } from '../../../../../../../../ui/gzForm/formField/types/form-validator';
import { IpValidator } from '../../../../../../../../ui/gzForm/validators/ip.validator';

export function customIpValidation(value: string): Promise<ValidationResult> {
  if (value === 'N/A' || value === '-') {
    return Promise.resolve({ valid: true });
  }
  return IpValidator('Invalid IP address')(value);
}
